import _ from "lodash";

import Stack from "components/Stack";

import NoProformaUploaded from "entities/Memo/components/Sections/NoProformaUploaded";
import { IMemoSection } from "entities/Memo/sdk";
import { useRentalDataManager } from "entities/Memo/utils";
import ProformaFloorArea from "entities/Proforma/components/ProformaFloorArea";

import PrintableSectionSummary from "../PrintableSectionSummary";

interface IPrintableSectionFloorArea {
  dealId: number;
  externalToken?: string;
  section?: IMemoSection;
}

const PrintableSectionFloorArea = ({
  dealId,
  externalToken,
  section,
}: IPrintableSectionFloorArea) => {
  const { data: rentalIncomeData } = useRentalDataManager({
    token: externalToken,
    dealId,
  });

  return (
    <>
      {rentalIncomeData &&
      !_.isEmpty(rentalIncomeData.rental_data.unit_type_and_floor_area) ? (
        <Stack spacing={2} data-testid="floor-area-section">
          <Stack justifyContent="space-between" spacing={4}>
            <ProformaFloorArea rentalIncomeData={rentalIncomeData} />
            <PrintableSectionSummary
              title="Floor Area description"
              category="Floor Area Descriptions"
              dealId={dealId}
              externalToken={externalToken}
            />
          </Stack>
        </Stack>
      ) : (
        <NoProformaUploaded title="Floor Area" />
      )}
    </>
  );
};

export default PrintableSectionFloorArea;
